import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import * as generics from '#components/generics/js/styles.js'
import { elements } from '../../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const checkboxes = all(`.${generics.modifiers.field_input.checkbox}`, button.closest(`.${elements.guardianship_features}`))
    if (checkboxes.length > 0) {
      for (const checkbox of checkboxes) {
        let field = checkbox.closest(`.${generics.elements.field}`)
        if (button.classList.contains(elements.guardianship_feature_select_all)) {
          checkbox.checked = true
          if (field.classList.contains(generics.modifiers.field.disabled)) {
            field.classList.remove(generics.modifiers.field.disabled)
          }
        }
        if (button.classList.contains(elements.guardianship_feature_unselect_all)) {
          if (!field.classList.contains(elements.guardianship_feature_activated)) {
            checkbox.checked = false
            if (!field.classList.contains(elements.guardianship_feature_activation)) {
              let parentItem = one(`.${elements.guardianship_feature_activation}`, checkbox.closest(`.${elements.guardianship_feature}`))
              let featureActivated = one(`.${elements.guardianship_feature_activated}`, checkbox.closest(`.${elements.guardianship_feature}`))
              if (parentItem && !featureActivated) {
                field.classList.add(generics.modifiers.field.disabled)
              }
            }
          }
        }
      }
    }
  }
})

export default button => {
  onClick.listen(button)
}